module.exports = __webpack_public_path__ + "static/media/empty-background.8fb23dbb.svg";